import React, { useState, useMemo } from 'react';
import CreationModal from '../../components/ui/CreationModal';
import ConfirmationDialog from '../../components/ui/ConfirmationDialog';
import CustomSnackbar from '../../components/ui/Snackbar';
import { transactionAPI } from '../../services/api';

const TransactionEditModal = ({ open, onClose, onSubmit, loading = false, transaction = null }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [formData, setFormData] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Field configuration for edit modal
  const descriptionFields = [
    {
      name: 'description',
      type: 'textarea',
      placeholder: 'Description',
      required: true
    }
  ];

  // Memoize initialData to pre-fill the form
  const initialData = useMemo(() => {
    return transaction ? 
      { description: transaction.description || '' } : 
      { description: '' };
  }, [transaction]);

  const handleSubmit = async (data) => {
    // Check if there are actual changes
    const originalDescription = transaction?.description || '';
    const newDescription = data.description?.trim() || '';
    
    if (originalDescription === newDescription) {
      // No changes - close modal without confirmation or API call
      onClose();
      return;
    }
    
    // There are changes - show confirmation dialog
    setFormData(data);
    setShowConfirmDialog(true);
  };

  const confirmEdit = async () => {
    if (!formData || !transaction) return;
    
    try {
      await transactionAPI.updateDescription(transaction.id, { description: formData.description.trim() });
      onSubmit(transaction.id, formData.description.trim());
      setShowConfirmDialog(false);
      setFormData(null);
      onClose();
    } catch (error) {
      console.error('Error updating transaction description:', error);
      setSnackbar({
        open: true,
        message: 'Erreur lors de la modification de la description',
        severity: 'error'
      });
    }
  };

  const handleClose = () => {
    setFormData(null);
    onClose();
  };

  return (
    <>
      <CreationModal
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        title="Modifier la description"
        fields={descriptionFields}
        submitButtonText="Enregistrer"
        loading={loading}
        initialData={initialData}
      />
      
      {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
        onConfirm={confirmEdit}
        title="Confirmer la modification"
        message="Êtes-vous sûr de vouloir modifier la description de cette transaction ?"
        confirmText="Enregistrer"
        cancelText="Annuler"
        loading={loading}
      />
      
      {/* Error Snackbar */}
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
      />
    </>
  );
};

export default TransactionEditModal;
